import { Schemas } from "../../schemas";
import { Integration } from "../../types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useState } from "react";
import z from "zod";
import { Box, Button, FormHelperText, TextField } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

export const ApiKeyForm: React.FC<{
  id: string,
  integration: Integration,
  onSubmit: (updatedIntegration: Integration) => void
}> = ({integration, onSubmit: onSubmitCallback}) => {

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<z.infer<typeof Schemas.integrationAuth['apiKey']>>({
    resolver: zodResolver(Schemas.integrationAuth['apiKey']),
    values: integration.auth ?? {} as any,
    defaultValues: {
      type: "apiKey",
      ready: true
    },
    mode: "onBlur",
  });
  const [submitError, setSubmitError] = useState<string | null>(null);

  const onInvalid = (errs: Record<string, unknown>) => {
    console.error(errs);
    setSubmitError("Error during submit");
  };

  const onSubmit = async (data: z.infer<typeof Schemas.integrationAuth.apiKey>) => {
    try {
      setSubmitError(null);
      onSubmitCallback({
        ...integration,
        auth: {
          ready: true,
          apiKey: data.apiKey,
          type: "apiKey"
        }
      });
    } catch (err: any) {
      console.error(err);
      const msg =
        err?.response?.data?.message ??
        err?.message ??
        "Something went wrong while creating the alert.";
      setSubmitError(String(msg));
    }
  };

  return <Box component="form" onSubmit={handleSubmit(onSubmit, onInvalid)}>
    <Box display="flex" gap={2.5} flexDirection="column">
      <TextField
        size="medium"
        placeholder="Your api key"
        error={!!errors.apiKey}
        {...register("apiKey", {
          onChange: () => submitError && setSubmitError(null),
        })}
      />
      {submitError && (
        <FormHelperText error sx={{ fontSize: 13, m: 0 }}>
          {submitError}
        </FormHelperText>
      )}
      <Button
        type="submit"
        variant="contained"
        startIcon={<CheckRoundedIcon fontSize="small" />}
      >
        Submit
      </Button>
    </Box>
  </Box>
}
